<template>
  <v-container class="fill-height d-flex justify-center align-center reset-password-container" fluid>
    <v-card class="justify-center">
      <v-card-title>
        <p class="heading-h3">Forget Your Password?</p>
      </v-card-title>
      <v-card-subtitle class="py-0">
        <p>
          Enter your email below to receive password reset instruction
        </p>
      </v-card-subtitle>
      <v-card-text>
        <v-form v-on:submit.prevent="forgot" v-model="isFormValid">
          <v-text-field outlined dense label="Email" name="email" type="text" required :rules="emailRules" v-model="email" />
          <v-btn color="secondary" type="submit" :disabled="!isFormValid">Send</v-btn>
          <v-divider class="my-4" />
          <div>If you have a child account, your parent can reset your password at</div>
          <div class="font-weight-bold">Your Children > Edit Profile.</div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: "Forgot",
    data() {
      return {
        email: "",
        isFormValid: false,
        emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
      };
    },
    methods: {
      forgot() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .post("/forgot", { email: this.email })
          .then((response) => this.forgotSuccess(response))
          .catch(() => this.forgotFail());
      },

      forgotSuccess(response) {
        this.$store.commit("setLoadingStatus", false);

        this.$store.commit("setError", {
          message: "Thanks! You will receive email to reset your password soon!",
          type: "success",
        });
      },

      forgotFail() {
        this.$store.commit("setLoadingStatus", false);

        this.$store.commit("setError", {
          message: "Sorry, something went wrong, please contact admin",
          type: "error",
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .reset-password-container {
    background: url(../../assets/reset_password_bcg_img.png);
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0px !important;
    padding: 8% 23.5%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Password/Forgot.vue